export default __webpack_public_path__ + "static/blog_bg-618092affa07a6c22319498401d85c80.jpeg";